import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { chiama } from './cliente.js';

/**
 * I parametri dell'azienda in cui si sta lavorando.
 *
 * Sono pochi e pesano: da qui escono i codici a barre di tutti gli articoli e
 * il filtro con cui entrano quelli di Business Central. Finora si cambiavano
 * solo con una `UPDATE` a mano sul database.
 */

export interface Impostazioni {
  barcodePrefixUs: string | null;
  barcodePrefixEu: string | null;
  bcArticleCodePrefixes: string | null;
  bcCustomerDefaultSectionalId: number | null;
  bcCustomerDefaultCurrency: string | null;
  csvDelimiter: string;
  /** A chi scrivere quando un import programmato si rompe. */
  importAlertEmails: string | null;
}

export interface Parametri {
  company: { id: number; code: string; name: string } | null;
  settings: Impostazioni;
  options: {
    sectionals: { id: number; label: string }[];
    currencies: { id: string; label: string }[];
  };
}

const CHIAVE = ['parametri'] as const;

export function useParametri() {
  return useQuery({
    queryKey: CHIAVE,
    queryFn: () => chiama<Parametri>('/api/settings'),
    retry: false,
  });
}

export function useSalvaParametri() {
  const client = useQueryClient();
  return useMutation({
    mutationFn: (dati: Partial<Impostazioni>) =>
      chiama<Parametri>('/api/settings', { metodo: 'PATCH', corpo: dati }),
    onSuccess: (esito) => client.setQueryData(CHIAVE, esito),
  });
}
